import { CONTACT } from "../data/content";
import { useNavScroll } from "./Navbar";
import { Link } from "react-router-dom";

const NAV = [
  { label: "Home", id: "top", route: true },
  { label: "About", id: "about" },
  { label: "Destinations", id: "destinations" },
  { label: "Wildlife", id: "wildlife" },
  { label: "Tours", id: "tours" },
  { label: "Adventure", id: "adventure" },
  { label: "Car Rental", id: "rentals" },
  { label: "Bike & Scooty", id: "rentals" },
  { label: "Contact", id: "contact" },
];

const LEGAL = [
  { label: "Privacy Policy", to: "/legal/privacy-policy" },
  { label: "Terms & Conditions", to: "/legal/terms-conditions" },
  { label: "Cancellation Policy", to: "/legal/cancellation-policy" },
];

export const Footer = () => {
  const navScroll = useNavScroll();
  return (
    <footer data-testid="footer" className="relative border-t border-gold/10 bg-forest-950">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-2.5 h-2.5 rotate-45 bg-gold" />
              <span className="font-serif text-2xl tracking-[0.18em] text-cream">HIDDENBIOMES</span>
            </div>
            <p className="font-serif italic text-sage mt-4">
              Discover the Wild. Explore the Unseen.
            </p>
            <p className="text-sm text-fog mt-5 leading-relaxed max-w-sm">
              Wildlife, adventure and nature journeys across Madhya Pradesh
              and beyond — planned with care, guided with passion.
            </p>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold block mb-5">
              Explore
            </span>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-3">
              {NAV.map((l) => (
                <li key={l.label}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={() => (l.route ? window.scrollTo({ top: 0 }) : navScroll(l.id))}
                    className="text-sm text-cream/60 hover:text-gold transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold block mb-5">
              Contact
            </span>
            <p className="text-sm text-cream/60 leading-relaxed">{CONTACT.address}</p>
            <a href={`tel:${CONTACT.phoneRaw}`} className="block text-sm text-cream/80 hover:text-gold mt-4 transition-colors">
              {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="block text-sm text-cream/80 hover:text-gold mt-1.5 transition-colors">
              {CONTACT.email}
            </a>
            <div className="flex gap-5 mt-6">
              {LEGAL.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="font-mono text-[10px] uppercase tracking-[0.15em] text-fog hover:text-gold transition-colors"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-gold/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-mono text-[10px] tracking-[0.15em] text-fog">
            © 2026 HIDDENBIOMES LLP. All Rights Reserved.
          </span>
          <span className="font-mono text-[10px] tracking-[0.15em] text-fog">
            GSTIN {CONTACT.gstin} · Indore, Madhya Pradesh
          </span>
        </div>
      </div>
    </footer>
  );
};
